<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 >Terms and conditions for website usage</h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1" >
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p  >Terms and conditions for website usage</p><br>
            </div> -->
            <div class="row">
                <div class="col">
                    <p>
                        Welcome to our website. If you continue to browse and use this website, you are agreeing to 
        comply with and be bound by the following terms and conditions of use, which together with 
        our privacy policy govern www.sarvadhnya.com's relationship with you in relation to this 
        website. If you disagree with any part of these terms and conditions, please do not use our website.
                    </p>
                    <p>
                        The term 'www.sarvadhnya.com' or 'us' or 'we' refers to the owner of the website. 
                        The term 'you' refers to the user or viewer of our website.
                    </p>
                    <h4>The use of this website is subject to the following terms of use:</h4>
                    <p>
                        The content of the pages of this website is for your general information and use only. It 
        is subject to change without notice. 
                        This website uses cookies to monitor browsing preferences. If you do allow cookies to be 
        used, the following personal information may be stored by us for use by third parties.
                    </p>
                    <p>
                        Neither we nor any third parties provide any warranty or guarantee as to the accuracy, 
        timeliness, performance, completeness or suitability of the information and materials found 
        or offered on this website for any particular purpose. You acknowledge that such 
        information and materials may contain inaccuracies or errors and we expressly exclude 
        liability for any such inaccuracies or errors to the fullest extent permitted by law.
        Your use of any information or materials on this website is entirely at your own risk, for 
        which we shall not be liable. It shall be your own responsibility to ensure that any 
        products, services or information available through this website meet your specific 
        requirements.
                    </p>
                    <p>
                        This website contains material which is owned by or licensed to us. This material includes, 
        but is not limited to, the design, layout, look, appearance and graphics. Reproduction is 
        prohibited other than in accordance with the copyright notice, which forms part of these 
        terms and conditions.
                    </p>
                    
                    <p>
                        Unauthorised use of this website may give rise to a claim for damages and/or be a criminal 
        offence.
                    </p>
                    <p>
                        From time to time this website may also include links to other websites. These links are 
        provided for your convenience to provide further information. They do not signify that we 
        endorse the website(s). We have no responsibility for the content of the linked website(s).
        Your use of this website and any dispute arising out of such use of the website is subject 
        to the laws of India.
        
                    </p>
                </div>
            </div>

        </div>
    </section>
</main>